import React, { useMemo } from 'react';
import useAxios from 'axios-hooks';
import FluentSelect from '../../../../Forms/FluentSelect';
import { Text, Spinner } from '@fluentui/react';
import { resourceTypes, endpointMap } from './CopyAndFunctions';
import PropTypes from 'prop-types';

function SwapResourceDropdowns({ resourceType, cobrandList }) {
    const params = new URLSearchParams();
    const cobrandIds = cobrandList && cobrandList.length > 0
        ? cobrandList.map(x => x.coBrandId)
        : [];
    (cobrandIds || []).forEach(id => params.append('cobrandIds', id));
    const resourceName = resourceTypes.find(rt => rt.id === resourceType)?.name || '';

    const allEndpoint = endpointMap(resourceType, `?${params.toString()}`);
    const [{ data: allItems, loading: allLoading }] = useAxios({ url: allEndpoint, method: 'get' }, { manual: false });

    const featuredEndpoint = `/internal/cobrand/featured/${resourceType}/?${params.toString()}`;
    const [{ data: featuredItems, loading: featuredLoading }] = useAxios({ url: featuredEndpoint, method: 'get' }, { manual: false });

    const findOptions = useMemo(() => {
        if (!featuredItems || !Array.isArray(featuredItems)) return [];
        return featuredItems.map(item => ({ value: { id: item.id, name: item.name }, label: item.name }));
    }, [featuredItems]);

    const replaceOptions = useMemo(() => {
        if (!allItems || !Array.isArray(allItems)) return [];
        return allItems.map(item => ({ value: { id: item.id, name: item.name }, label: item.name }));
    }, [allItems]);

    if (allLoading || featuredLoading) {
        return <Spinner className="mt10" label="Loading resources..." />;
    }

    return (
        <>
        <div style={{ margin: '25px 0', maxWidth: 600 }}>
            <Text variant="medium">
                Select the {resourceName} resource you want to replace.
            </Text>
            <FluentSelect
                name="findResource"
                label="Find Resource (currently featured for selected cobrands)"
                options={findOptions}
                isClearable={false}
            />
            {findOptions.length === 0 ? (
                <Text variant="small" style={{ color: '#c8560f' }}>
                    No featured {resourceName} resources found for the selected cobrands. Please select a different resource type or add featured {resourceName} resources to the selected cobrands.
                </Text>
                ) : (
                <Text variant="small">
                    Resources currently featured for the selected cobrands. A resource may be featured for multiple clients, cobrand tags, and cobrands.
                </Text>
            )}
        </div>
        <div style={{ margin: '50px 0', maxWidth: 600 }}>
            <Text variant="medium">
                Select a resource to replace the {resourceName} resource above. 
            </Text>
            <FluentSelect
                name="replaceResource"
                label="Replace With Resource (all shared resources for selected cobrands)"
                options={replaceOptions}
                isClearable={false}
            />
            <Text variant="small">
                Resources shared across the selected cobrands. If you do not see a resource, try removing a client, cobrand tag, or cobrand.
            </Text>
        </div>
        </>
    );
}

SwapResourceDropdowns.propTypes = {
    resourceType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    cobrandList: PropTypes.array.isRequired,
};

export default SwapResourceDropdowns;
